import Portal from './PortalCompat';
import PortalWithState from './PortalWithState';

export { Portal, PortalWithState };


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/react-portal/es/index.js
// module id = 1077
// module chunks = 5